import React, { useState } from 'react';
import { supabase } from '../../supabase';
import '../../styles/Subscription.css';

const SUPABASE_FUNCTION_URL = 'https://yeybluihiblysywmazen.supabase.co/functions/v1/create-checkout-session';

const UpgradeModal = ({ email, onDismiss }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleUpgrade = async () => {
        setLoading(true);
        setError('');
        try {
            const { data, error: fnError } = await supabase.functions.invoke('create-checkout-session', {
                body: { email },
            });
            if (fnError || !data?.url) {
                throw new Error(fnError?.message || 'Could not start checkout.');
            }
            window.location.href = data.url;
        } catch (e) {
            setLoading(false);
            setError(e.message || 'Something went wrong. Please try again.');
        }
    };

    return (
        <div className="modal-backdrop" onClick={e => { if (e.target === e.currentTarget) onDismiss(); }}>
            <div className="modal-card">
                <span className="modal-icon">⭐</span>
                <h2 className="modal-title">Upgrade to Pro</h2>
                <p className="modal-body">
                    You've reached the free tier limit. Upgrade to unlock more categories, products, and portfolio items.
                </p>

                <div className="modal-limits">
                    <p className="modal-limits-title">What you get</p>
                    <div className="modal-limit-row">
                        <span className="modal-limit-label">Categories / Sections</span>
                        <div className="modal-limit-values">
                            <span className="modal-limit-free">Free: 2</span>
                            <span className="modal-limit-pro">Pro: 9</span>
                        </div>
                    </div>
                    <div className="modal-limit-row">
                        <span className="modal-limit-label">Products per category</span>
                        <div className="modal-limit-values">
                            <span className="modal-limit-free">Free: 5</span>
                            <span className="modal-limit-pro">Pro: 20</span>
                        </div>
                    </div>
                    <div className="modal-limit-row">
                        <span className="modal-limit-label">Portfolio items per section</span>
                        <div className="modal-limit-values">
                            <span className="modal-limit-free">Free: 2</span>
                            <span className="modal-limit-pro">Pro: 3</span>
                        </div>
                    </div>
                </div>

                {error && <p style={{ color: '#b02828', fontSize: 13, marginBottom: 12 }}>{error}</p>}

                <button className="modal-cta" onClick={handleUpgrade} disabled={loading}>
                    {loading ? 'Opening checkout…' : 'Subscribe — Upgrade now'}
                </button>
                <button className="modal-dismiss" onClick={onDismiss}>
                    Not now
                </button>
            </div>
        </div>
    );
};

export { SUPABASE_FUNCTION_URL };
export default UpgradeModal;
